export default __webpack_public_path__ + "static/media/vol3_2.2a8f054c.png";